import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { mountAfterUpdateCheck } from "./lib/checkForUpdate";
import { configureNativePlatform } from "./lib/platform";
import { initSentry } from "./lib/sentry";
import { startAppOpenTelemetry } from "./lib/appOpenTelemetry";

// Antes de qualquer coisa: só o que roda DEPOIS do init é capturado.
// No-op se VITE_SENTRY_DSN não estiver no build.
initSentry();
startAppOpenTelemetry();

// Preload logo to prevent flash on navigation
import onDietLogo from "@/assets/logo_ondiet.webp";
const preloadImg = new Image();
preloadImg.src = onDietLogo;

// Bancada de design: intercepta fetch e a ponte do Median antes do render.
// `import.meta.env.DEV` garante que isto some do build de produção — o Vite
// avalia a constante e o bloco inteiro cai no tree-shaking.
async function bootstrap() {
  // A bancada precisa instalar o interceptor antes dos providers: o gate da
  // Gema é a primeira chamada HTTP da árvore e não pode escapar para a API real.
  if (import.meta.env.DEV && import.meta.env.VITE_MOCK_MODE === "true") {
    const { installMocks } = await import("./mocks");
    installMocks();
  }
  void configureNativePlatform();
  await mountAfterUpdateCheck(() => createRoot(document.getElementById("root")!).render(<App />));
}
void bootstrap();
